export default function Filtro() {
    const opcionesFiltro = ["Todos", "Apertura digital", "Mejor tasa", "Nuestros recomendados"];
    const calificaciones = ["Todos", "A", "A-", "AA-", "AA", "A+", "AA+", "AAA"];
  
    return (
      <div className="bg-[#e8f2f4] p-6 rounded-xl shadow-md w-full max-w-[400px]">
        <h3 className="text-[#0346a4] font-extrabold text-xl mb-2">Filtrar bancos por:</h3>
        <div className="flex flex-wrap gap-2 mb-4">
          {opcionesFiltro.map((opcion) => (
            <button
              key={opcion}
              className="bg-white text-[#004cb6] font-bold px-4 py-2 rounded-lg shadow-[0px_2px_4px_rgba(0,0,0,0.2)] hover:bg-[#cce0ff]"
            >
              {opcion}
            </button>
          ))}
        </div>
  
        <h3 className="text-[#0346a4] font-extrabold text-xl mb-2">Nivel de calificación:</h3>
        <div className="flex flex-wrap gap-2 mb-4">
          {calificaciones.map((calificacion) => (
            <button
              key={calificacion}
              className="bg-white text-[#004cb6] font-bold px-4 py-2 rounded-lg shadow-[0px_2px_4px_rgba(0,0,0,0.2)] hover:bg-[#cce0ff]"
            >
              {calificacion}
            </button>
          ))}
        </div>
  
        <p className="text-[#0346a4] font-bold text-lg">
          Conoce más sobre cada calificación. <span className="underline">Aquí te contamos.</span>
        </p>
      </div>
    );
  }
  